// extracted by css-extract-rspack-plugin
export default {"paragraph":"src-Paragraph-paragraph-fd599b6d"};